var exports = {
  "Bx": "NameWithDetailsContainer__ZuinWe",
  "eV": "NameWithDetailsTruncate__04vPbZ",
  "lE": "NameWithDetailsToken__e0R_wZ",
  "CU": "NameWithDetailsTokenSuccess__EpCDpM",
  "Vs": "NameWithDetailsTokenAttention__ToqQO8",
  "uX": "NameWithDetailsTokenDanger__LL0DoA",
  "bW": "NameWithDetailsTokenPadded__-wuzmc",
  "bO": "NameWithDetailsBoxFontMedium__b0boS9",
};

module.exports = exports;
